// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__tooltipContainer--zXWDL {
  position: relative;
  width: inherit;
}
.style__tooltip--LOU6P {
  display: block;
  font-family: 'Inter Regular', sans-serif;
  letter-spacing: 0.5px;
  white-space: pre-line;
}
.style__tooltip--LOU6P svg {
  cursor: pointer;
}
.style__noArrow--WTXwG::after {
  display: none;
}
.style__tooltip--LOU6P::before, .style__tooltip--LOU6P::after {
  position: absolute;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease-in-out;
  width: max-content;
}
.style__tooltip--LOU6P:hover::before, .style__tooltip--LOU6P:hover::after {
  opacity: 1;
  visibility: visible;
}
.style__tooltip--LOU6P::before {
  content: attr(data-tooltip);
  z-index: 9999999999;
  color: #fff;
  background: #313235;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
  font-family: 'Inter Regular', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 0.75rem;
  line-height: 1rem;
  box-shadow: 0 0.75rem 1rem -0.25rem rgba(12, 13, 13, 0.1), 0 0.25rem 6px -0.125rem rgba(12, 13, 13, 0.05);
}
.style__tooltip--LOU6P::after {
  content: '';
  width: 0;
  height: 0;
}
.style__tooltipTop--r7IK6::before, .style__tooltipTop--r7IK6::after {
  bottom: 100%;
  left: 50%;
  transform: translate(-50%);
  margin-bottom: 15px;
}
.style__tooltipLeftCorner--T3zda::before, .style__tooltipLeftCorner--T3zda::after {
  transform: translate(-5%);
}
.style__tooltipRightCorner--spK_I::before, .style__tooltipRightCorner--spK_I::after {
  transform: translate(-90%);
}
.style__tooltipTop--r7IK6::after {
  margin-bottom: 0.5rem;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #313235;
}
.style__tooltipBottom--Tt8_7::before, .style__tooltipBottom--Tt8_7::after {
  top: 100%;
  left: 50%;
  transform: translate(-50%);
  margin-top: 15px;
}
.style__tooltipBottom--Tt8_7::after {
  margin-top: 0.5rem;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #313235;
}
.style__tooltipRight--r1LF1::before, .style__tooltipRight--r1LF1::after {
  top: 50%;
  left: 100%;
  transform: translate(0, -50%);
  margin-left: 15px;
}
.style__tooltipRight--r1LF1::after {
  margin-left: 0.5rem;
  border-top: 7px solid transparent;
  border-right: 7px solid #313235;
  border-bottom: 7px solid transparent;
}
.style__tooltipLeft--V_ciy::before, .style__tooltipLeft--V_ciy::after {
  top: 50%;
  right: 100%;
  transform: translate(0, -50%);
  margin-right: 15px;
}
.style__tooltipLeft--V_ciy::after {
  margin-right: 0.5rem;
  border-top: 7px solid transparent;
  border-left: 7px solid #313235;
  border-bottom: 7px solid transparent;
}
`, "",{"version":3,"sources":["webpack://./../components/src/Tooltip/style.less","webpack://./../components/src/shadows.less"],"names":[],"mappings":"AAGA;EAEI,kBAAA;EACA,cAAA;AAHJ;AAAA;EAOI,cAAA;EACA,wCAAA;EACA,qBAAA;EACA,qBAAA;AAJJ;AANA;EAaM,eAAA;AAJN;AATA;EAkBI,aAAA;AANJ;AAZA;EAuBI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;AAPJ;AApBA;EAgCI,UAAA;EACA,mBAAA;AARJ;AAzBA;EAqCI,2BAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,wCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EC3BF,yGAAA;ADmBF;AAvCA;EAoDI,WAAA;EACA,QAAA;EACA,SAAA;AAVJ;AA5CA;EA2DI,YAAA;EACA,SAAA;EACA,0BAAA;EACA,mBAAA;AAXJ;AAnDA;EAmEI,yBAAA;AAZJ;AAvDA;EAwEI,0BAAA;AAbJ;AA3DA;EA4EI,qBAAA;EACA,kCAAA;EACA,mCAAA;EACA,6BAAA;AAdJ;AAjEA;EAoFI,SAAA;EACA,SAAA;EACA,0BAAA;EACA,gBAAA;AAfJ;AAxEA;EA2FI,kBAAA;EACA,kCAAA;EACA,mCAAA;EACA,gCAAA;AAhBJ;AA9EA;EAmGI,QAAA;EACA,UAAA;EACA,6BAAA;EACA,iBAAA;AAjBJ;AArFA;EA0GI,mBAAA;EACA,iCAAA;EACA,+BAAA;EACA,oCAAA;AAlBJ;AA3FA;EAkHI,QAAA;EACA,WAAA;EACA,6BAAA;EACA,kBAAA;AAnBJ;AAlGA;EAyHI,oBAAA;EACA,iCAAA;EACA,8BAAA;EACA,oCAAA;AApBJ","sourcesContent":["@import '../shadows';\n@import '../spacing';\n\n:local {\n  .tooltipContainer {\n    position: relative;\n    width: inherit;\n  }\n\n  .tooltip {\n    display: block;\n    font-family: 'Inter Regular', sans-serif;\n    letter-spacing: 0.5px;\n    white-space: pre-line;\n\n    svg {\n      cursor: pointer;\n    }\n  }\n\n  .noArrow::after {\n    display: none;\n  }\n\n  .tooltip::before,\n  .tooltip::after {\n    position: absolute;\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity 0.3s ease-in-out;\n    width: max-content;\n  }\n\n  .tooltip:hover::before,\n  .tooltip:hover::after {\n    opacity: 1;\n    visibility: visible;\n  }\n\n  .tooltip::before {\n    content: attr(data-tooltip);\n    z-index: 9999999999;\n    color: #fff;\n    background: @color-asphalt-grey-020;\n    border-radius: @spacing-50;\n    padding: @spacing-50 @spacing-75;\n    font-family: 'Inter Regular', sans-serif;\n    font-style: normal;\n    font-weight: 500;\n    font-size: @spacing-75;\n    line-height: @spacing-100;\n    .sys-elevation-shadow-level3();\n  }\n\n  .tooltip::after {\n    content: '';\n    width: 0;\n    height: 0;\n  }\n\n  .tooltipTop::before,\n  .tooltipTop::after {\n    bottom: 100%;\n    left: 50%;\n    transform: translate(-50%);\n    margin-bottom: 15px;\n  }\n\n  .tooltipLeftCorner::before,\n  .tooltipLeftCorner::after {\n    transform: translate(-5%);\n  }\n\n  .tooltipRightCorner::before,\n  .tooltipRightCorner::after {\n    transform: translate(-90%);\n  }\n\n  .tooltipTop::after {\n    margin-bottom: @spacing-50;\n    border-left: 7px solid transparent;\n    border-right: 7px solid transparent;\n    border-top: 7px solid @color-asphalt-grey-020;\n  }\n\n  .tooltipBottom::before,\n  .tooltipBottom::after {\n    top: 100%;\n    left: 50%;\n    transform: translate(-50%);\n    margin-top: 15px;\n  }\n\n  .tooltipBottom::after {\n    margin-top: @spacing-50;\n    border-left: 7px solid transparent;\n    border-right: 7px solid transparent;\n    border-bottom: 7px solid @color-asphalt-grey-020;\n  }\n\n  .tooltipRight::before,\n  .tooltipRight::after {\n    top: 50%;\n    left: 100%;\n    transform: translate(0, -50%);\n    margin-left: 15px;\n  }\n\n  .tooltipRight::after {\n    margin-left: @spacing-50;\n    border-top: 7px solid transparent;\n    border-right: 7px solid @color-asphalt-grey-020;\n    border-bottom: 7px solid transparent;\n  }\n\n  .tooltipLeft::before,\n  .tooltipLeft::after {\n    top: 50%;\n    right: 100%;\n    transform: translate(0, -50%);\n    margin-right: 15px;\n  }\n\n  .tooltipLeft::after {\n    margin-right: @spacing-50;\n    border-top: 7px solid transparent;\n    border-left: 7px solid @color-asphalt-grey-020;\n    border-bottom: 7px solid transparent;\n  }\n}\n","@import 'colors';\n@import 'spacing';\n\n.sys-elevation-shadow-level0() {\n  box-shadow: 0 0 0 0 @color-asphalt-grey-005;\n}\n\n.sys-elevation-shadow-level1() {\n  box-shadow: 0 1px 3px 0 fade(@color-asphalt-grey-005, 10%),\n    0 1px @spacing-15 0 fade(@color-asphalt-grey-005, 6%);\n}\n\n.sys-elevation-shadow-level2() {\n  box-shadow: 0 @spacing-25 @spacing-50 -@spacing-15 fade(@color-asphalt-grey-005, 10%),\n    0 0 @spacing-25 -@spacing-15 fade(@color-asphalt-grey-005, 6%);\n}\n\n.sys-elevation-shadow-level2() {\n  box-shadow: 0 4px 8px -2px fade(@color-asphalt-grey-005, 10%),\n    0px 0px 4px -2px fade(@color-asphalt-grey-005, 6%);\n}\n\n.sys-elevation-shadow-level3() {\n  box-shadow: 0 @spacing-75 @spacing-100 -@spacing-25 fade(@color-asphalt-grey-005, 10%),\n    0 @spacing-25 6px -@spacing-15 fade(@color-asphalt-grey-005, 5%);\n}\n\n.sys-elevation-shadow-level4() {\n  box-shadow: 0 20px @spacing-150 -@spacing-25 fade(@color-asphalt-grey-005, 10%),\n    0 @spacing-50 @spacing-50 -@spacing-25 fade(@color-asphalt-grey-005, 4%);\n}\n\n.sys-elevation-shadow-level5() {\n  box-shadow: 0 @spacing-150 @spacing-300 -@spacing-75 fade(@color-asphalt-grey-005, 15%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltipContainer": `style__tooltipContainer--zXWDL`,
	"tooltip": `style__tooltip--LOU6P`,
	"noArrow": `style__noArrow--WTXwG`,
	"tooltipTop": `style__tooltipTop--r7IK6`,
	"tooltipLeftCorner": `style__tooltipLeftCorner--T3zda`,
	"tooltipRightCorner": `style__tooltipRightCorner--spK_I`,
	"tooltipBottom": `style__tooltipBottom--Tt8_7`,
	"tooltipRight": `style__tooltipRight--r1LF1`,
	"tooltipLeft": `style__tooltipLeft--V_ciy`
};
export default ___CSS_LOADER_EXPORT___;
